import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import * as moment from 'moment';
import { appModuleAnimation } from '@shared/animations/routerTransition';

import {
  AccountJournalReportServiceProxy,
  CommonLookupServiceProxy,
  ProfitLossDto,
  DropDownLookupDto,
  ComboboxItemDto
} from '@shared/service-proxies/service-proxies';
import { AppSessionService } from '@shared/common/session/app-session.service';

@Component({
  selector: 'app-profit-and-loss',
  standalone: false,
  encapsulation: ViewEncapsulation.None,
  animations: [appModuleAnimation()],
  templateUrl: './profit-and-loss.component.html'
})
export class ProfitAndLossComponent implements OnInit {
    loading = false;

  // Dropdowns
  locations: DropDownLookupDto[] = [];
  accounts: ComboboxItemDto[] = [];

  selectedLocations: any[] = [];
  selectedAccounts: any[] = [];

  dateRange: Date[] = [];

  // Results
  profitAndLoss: ProfitLossDto[] = [];
  netProfitAmounts: any[] = [];
  headerDates: string[] = [];

  constructor(
    private reportService: AccountJournalReportServiceProxy,
    private lookupService: CommonLookupServiceProxy,
    private appSession: AppSessionService,
    private route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.initializeDateRange();
    this.loadLocations();
    this.loadFromRouteParams();
  }

  initializeDateRange() {
    const today = new Date();
    this.dateRange = [today, today];
  }

  loadLocations() {
    this.lookupService.getAllLocationForTableDropdown()
      .subscribe(res => {
        this.locations = res;
        const defaultLoc = this.locations.find(l => l.id === this.appSession.user.locationId);
        if (defaultLoc) this.selectedLocations = [defaultLoc];
      });
  }

  loadFromRouteParams() {
    this.route.queryParams.subscribe(params => {
      if (params['startDate']) this.dateRange[0] = new Date(params['startDate']);
      if (params['endDate']) this.dateRange[1] = new Date(params['endDate']);

      if (params['locations']) {
        const ids = params['locations'].split('-').map((x: string) => Number(x));
        this.selectedLocations = this.locations.filter(l => ids.includes(l.id));
      }

      setTimeout(() => this.getDetails(), 3000);
    });
  }

  setDateRange(type: string) {
    const today = new Date();
    let start = today;
    let end = today;

    switch (type) {
      case '7days': start = new Date(today.getFullYear(), today.getMonth(), today.getDate() - 6); break;
      case '30days': start = new Date(today.getFullYear(), today.getMonth(), today.getDate() - 29); break;
      case 'thisMonth': start = new Date(today.getFullYear(), today.getMonth(), 1); end = new Date(today.getFullYear(), today.getMonth() + 1, 0); break;
      case 'lastMonth': start = new Date(today.getFullYear(), today.getMonth() - 1, 1); end = new Date(today.getFullYear(), today.getMonth(), 0); break;
    }

    this.dateRange = [start, end];
  }

  getDetails() {

    if (!this.dateRange?.length) return;

    const startDate = moment(this.dateRange[0]).format('YYYY-MM-DD');
    const endDate = moment(this.dateRange[1]).format('YYYY-MM-DD');

    const locations = this.selectedLocations.length
      ? this.selectedLocations
      : this.locations;

    const accounts = this.selectedAccounts.length
      ? this.selectedAccounts
      : this.accounts;

    this.loading = true;

    this.reportService.getProfitAndLoss(
        0,                             // locationId (not used)
        endDate as any,                // endDate
        0,                             // accountId (optional)
        startDate as any,              // startDate
        this.appSession.user.locationId,           // defaultLocationId
        locations,                     // locations[]
        [],                      // accounts[]
        null,                          // transactionNo
        0,                             // customerVendorId
        0,                             // vendorId
        null,                          // journalNo
        false,                         // isAuto
        0,                             // defaultPeriod
        undefined,                     // sorting
    )
    .subscribe(result => {
      this.profitAndLoss = result;

      if (result.length && result[0].items.length) {
        this.headerDates = result[0].items[0].amounts.map(a => a.journalDateStr);
      }

      this.netProfitAmounts = result[0]?.netProfitAmounts || [];
      this.loading = false;
    });
  }

  exportExcel() {
    const startDate = moment(this.dateRange[0]).format('YYYY-MM-DD');
    const endDate = moment(this.dateRange[1]).format('YYYY-MM-DD');

    const locations = this.selectedLocations.length ? this.selectedLocations : this.locations;

    this.loading = true;

    this.reportService.getProfitAndLoss(
        0,                             // locationId (not used)
        endDate as any,                // endDate
        0,                             // accountId (optional)
        startDate as any,              // startDate
        this.appSession.user.locationId,           // defaultLocationId
        locations,                     // locations[]
        [],                      // accounts[]
        null,                          // transactionNo
        0,                             // customerVendorId
        0,                             // vendorId
        null,                          // journalNo
        false,                         // isAuto
        0,                             // defaultPeriod
        undefined,                     // sorting
    ).subscribe(file => {
     /* abp.downloadTempFile(file);*/
      this.loading = false;
    });
  }

}
